import { events as en_events } from "../en/events";

/** events — ES slice (204 keys). */
export const events: Record<keyof typeof en_events, string> = {
  events_title: "Eventos",
  events_nearby: "Cerca de ti",
  events_all: "Todos los eventos",
  events_my_events: "Mis eventos",
  events_create: "Crear evento",
  events_list_empty_title: "No se encontraron eventos",
  events_list_empty_description: "Vuelve más tarde o crea tu propio evento",
  events_list_loading: "Cargando eventos...",
  events_list_error: "No se pudieron cargar los eventos",
  events_list_search_placeholder: "Buscar eventos...",
  events_list_filter_title: "Filtrar eventos",
  events_filter_all: "Todos",
  events_filter_today: "Hoy",
  events_filter_this_week: "Esta semana",
  events_filter_this_month: "Este mes",
  events_filter_online: "En línea",
  events_filter_in_person: "Presencial",
  events_filter_free: "Gratis",
  events_filter_paid: "De pago",
  events_filter_apply: "Aplicar filtros",
  events_filter_clear: "Limpiar",
  events_card_free: "Gratis",
  events_card_from_price: "Desde {price}",
  events_card_sold_out: "Agotado",
  events_card_tickets_left: "Quedan {count} entradas",
  events_card_online: "Evento en línea",
  events_card_distance: "A {distance} mi",
  events_detail_about: "Acerca de",
  events_detail_location: "Ubicación",
  events_detail_date_time: "Fecha y hora",
  events_detail_organizer: "Organizador",
  events_detail_performers: "Artistas",
  events_detail_tickets: "Entradas",
  events_detail_get_tickets: "Conseguir entradas",
  events_detail_buy_ticket: "Comprar entrada",
  events_detail_reserve_spot: "Reservar lugar",
  events_detail_view_ticket: "Ver mi entrada",
  events_detail_share: "Compartir evento",
  events_detail_report: "Reportar evento",
  events_detail_directions: "Cómo llegar",
  events_detail_online_event: "Este es un evento en línea",
  events_detail_join_online: "Unirse en línea",
  events_status_draft: "Borrador",
  events_status_published: "Publicado",
  events_status_cancelled: "Cancelado",
  events_status_completed: "Finalizado",
  events_form_title: "Título del evento",
  events_form_title_placeholder: "Dale un nombre a tu evento",
  events_form_description: "Descripción",
  events_form_description_placeholder:
    "Cuéntale a la gente de qué trata tu evento...",
  events_form_start_date: "Fecha y hora de inicio",
  events_form_end_date: "Fecha y hora de fin",
  events_form_location: "Ubicación",
  events_form_location_placeholder: "Añade la ubicación del evento",
  events_form_online_event: "Este es un evento en línea",
  events_form_online_url: "URL del evento",
  events_form_online_url_placeholder: "https://zoom.us/...",
  events_form_price: "Precio de la entrada",
  events_form_price_free: "Evento gratuito",
  events_form_max_tickets: "Entradas máximas",
  events_form_max_tickets_placeholder: "Ilimitadas",
  events_form_tags: "Etiquetas del evento",
  events_form_tags_placeholder: "Selecciona etiquetas...",
  events_form_photos: "Fotos del evento",
  events_form_add_photos: "Añadir fotos",
  events_form_visibility: "Visibilidad",
  events_form_visibility_public: "Público",
  events_form_visibility_private: "Privado",
  events_form_visibility_followers: "Solo seguidores",
  events_form_save_draft: "Guardar como borrador",
  events_form_publish: "Publicar evento",
  events_form_update: "Actualizar evento",
  events_form_creating: "Creando evento...",
  events_form_updating: "Actualizando evento...",
  events_validation_title_required: "El título del evento es obligatorio",
  events_validation_start_date_required: "La fecha de inicio es obligatoria",
  events_validation_end_date_required: "La fecha de fin es obligatoria",
  events_validation_end_after_start:
    "La fecha de fin debe ser posterior a la de inicio",
  events_validation_location_required:
    "La ubicación es obligatoria para eventos presenciales",
  events_validation_online_url_required:
    "La URL es obligatoria para eventos en línea",
  events_success_created: "Evento creado correctamente",
  events_success_updated: "Evento actualizado correctamente",
  events_success_published: "Evento publicado correctamente",
  events_success_cancelled: "Evento cancelado",
  events_success_deleted: "Evento eliminado",
  events_admin_edit: "Editar evento",
  events_admin_manage_tickets: "Gestionar entradas",
  events_admin_cancel_event: "Cancelar evento",
  events_admin_delete_event: "Eliminar evento",
  events_admin_cancel_confirm_title: "¿Cancelar evento?",
  events_admin_cancel_confirm_message:
    "¿Seguro que quieres cancelar este evento? Se notificará a todas las personas con entrada.",
  events_admin_delete_confirm_title: "¿Eliminar evento?",
  events_admin_delete_confirm_message:
    "¿Seguro que quieres eliminar este evento? Esta acción no se puede deshacer.",
  tickets_my_tickets: "Mis entradas",
  tickets_upcoming: "Próximas",
  tickets_past: "Pasadas",
  tickets_empty_title: "Aún no tienes entradas",
  tickets_empty_description:
    "Cuando consigas entradas para eventos, aparecerán aquí",
  tickets_loading: "Cargando entradas...",
  tickets_card_active: "Activa",
  tickets_card_used: "Usada",
  tickets_card_cancelled: "Cancelada",
  tickets_card_expired: "Caducada",
  tickets_card_banned: "Bloqueada",
  tickets_card_view: "Ver entrada",
  tickets_card_type_standard: "Estándar",
  tickets_card_type_vip: "VIP",
  tickets_card_type_early_bird: "Anticipada",
  tickets_card_type_group: "Grupo",
  tickets_qr_title: "Tu entrada",
  tickets_qr_scan_instruction: "Muestra este código QR en la entrada",
  tickets_qr_generating: "Generando código QR...",
  tickets_qr_error: "No se pudo generar el código QR",
  tickets_qr_refresh: "Actualizar código QR",
  tickets_qr_valid_until: "Válida hasta {time}",
  tickets_qr_ticket_id: "ID de entrada: {id}",
  tickets_purchase_title: "Conseguir entrada",
  tickets_purchase_select_type: "Selecciona el tipo de entrada",
  tickets_purchase_price: "Precio",
  tickets_purchase_free: "Gratis",
  tickets_purchase_confirm: "Confirmar",
  tickets_purchase_processing: "Procesando...",
  tickets_purchase_success: "¡Entrada comprada correctamente!",
  tickets_purchase_error: "No se pudo comprar la entrada",
  tickets_purchase_sold_out: "Lo sentimos, este evento está agotado",
  tickets_purchase_already_have: "Ya tienes una entrada para este evento",
  tickets_cancel_title: "¿Cancelar entrada?",
  tickets_cancel_message:
    "¿Seguro que quieres cancelar esta entrada? Esta acción no se puede deshacer.",
  tickets_cancel_confirm: "Cancelar entrada",
  tickets_cancel_success: "Entrada cancelada",
  tickets_cancel_error: "No se pudo cancelar la entrada",
  tickets_checkin_title: "Registrarse",
  tickets_checkin_scan: "Escanear código QR",
  tickets_checkin_manual: "Introducir ID de entrada",
  tickets_checkin_success: "¡Registro exitoso!",
  tickets_checkin_already_used: "Esta entrada ya se ha utilizado",
  tickets_checkin_invalid: "Entrada no válida",
  tickets_checkin_cancelled: "Esta entrada ha sido cancelada",
  tickets_checkin_wrong_event: "Esta entrada es para otro evento",
  tickets_payment_pending: "Pago pendiente",
  tickets_payment_paid: "Pagado",
  tickets_payment_free: "Gratis",
  tickets_payment_refunded: "Reembolsado",
  events_miniapp_search_placeholder: "Buscar eventos...",
  events_miniapp_no_events: "Aún no hay eventos",
  events_miniapp_no_events_description:
    "Sé el primero en crear un evento y reunir a la gente.",
  events_miniapp_new_event: "Nuevo evento",
  events_miniapp_detail: "Detalles del evento",
  events_miniapp_buy_ticket: "Comprar entrada",
  events_miniapp_sold_out: "Agotado",
  events_miniapp_free: "Gratis",
  events_miniapp_tickets_left: "Quedan {count} entradas",
  events_miniapp_date: "Fecha",
  events_miniapp_price: "Precio",
  events_miniapp_description: "Descripción",
  events_miniapp_status_upcoming: "Próximo",
  events_miniapp_status_ongoing: "En curso",
  events_miniapp_status_completed: "Finalizado",
  events_miniapp_status_cancelled: "Cancelado",
  events_miniapp_organizer: "Organizador",
  events_miniapp_tags: "Etiquetas",
  events_miniapp_address: "Dirección",
  events_miniapp_my_tickets: "Mis entradas",
  events_miniapp_no_tickets: "Aún no tienes entradas",
  events_miniapp_browse_events: "Explorar eventos",
  events_miniapp_ticket_status_active: "Activa",
  events_miniapp_ticket_status_used: "Usada",
  events_miniapp_ticket_status_cancelled: "Cancelada",
  events_miniapp_ticket_sales: "Venta de entradas",
  events_miniapp_total_tickets: "Total",
  events_miniapp_checked_in: "Registrados",
  events_miniapp_revenue: "Ingresos",
  events_miniapp_cancel_event: "Cancelar evento",
  events_miniapp_delete_event: "Eliminar evento",
  events_miniapp_you_have_ticket: "Tienes una entrada",
  events_miniapp_title_label: "Título del evento",
  events_miniapp_description_label: "Descripción",
  events_miniapp_price_label: "Precio ($)",
  events_miniapp_max_tickets_label: "Entradas máximas",
  events_miniapp_creating: "Creando...",
  events_miniapp_purchasing: "Comprando...",
  events_miniapp_company_events: "Eventos de la empresa",
  events_miniapp_view_tickets: "Ver entradas",
  events_miniapp_manage: "Gestionar",
  events_miniapp_create: "Crear",
  events_miniapp_required_hint: "Los campos marcados con * son obligatorios",
  events_miniapp_error_title_required: "Escribe un título para el evento",
  events_miniapp_error_date_required: "Elige la fecha y hora de inicio",
  events_miniapp_error_date_past: "La hora de inicio debe ser en el futuro",
  events_miniapp_business_badge: "Empresa",
  events_miniapp_hosted_by: "Organizado por",
  events_miniapp_events_count: "{count} evento(s)",
  events_miniapp_featured: "Destacado",
  events_miniapp_all_events: "Todos los eventos",
  events_miniapp_tab_upcoming: "Próximos",
  events_miniapp_tab_past: "Pasados",
  events_miniapp_tab_tickets: "Entradas",
  events_miniapp_no_past_events: "No hay eventos pasados",
  events_miniapp_view_qr: "Ver entrada / código QR",
  events_miniapp_ticket_qr_title: "Código QR del evento",
  events_miniapp_ticket_qr_scan_hint:
    "Muestra este código en la entrada para registrarte.",
  events_miniapp_ticket_qr_unavailable:
    "Código QR no disponible. Es posible que la entrada esté inactiva.",
  events_miniapp_receipt_title: "Recibo",
  events_miniapp_your_booking: "Tu reserva",
  events_miniapp_event: "Evento",
  events_miniapp_ticket_type: "Entrada",
  events_miniapp_price_details: "Detalles del precio",
  events_miniapp_app_fee: "Comisión de la app",
  events_miniapp_total: "Total",
};
